<template>
  <input-widget :model="model"
                :attribute="attribute"
                :label="label"
                :options="options"
                :multiple="multiple"
                type="select2"
                :display-field="displayFieldFunction"
                value-field="country_code"
                :hint="hint"
                :items="countries"
                :rules="rules"
                @select2Select="onSelect"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import {ARTISIO_ACTIVE_LANGUAGE} from "@/modules/constants";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CountrySelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(['countries']),
    },
    methods: {
      onSelect(data) {
        this.$emit('select', data);
      },
      displayFieldFunction(item) {
        let currentLang = localStorage.getItem(ARTISIO_ACTIVE_LANGUAGE)
        if (item.translations && item.translations[currentLang]) {
          return item.translations[currentLang]
        }
        return item.name
      }
    },
  }
</script>

<style scoped>

</style>
